export default "__VITE_ASSET__BjeyFZMa__"